<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

* {
  margin: 0;
  padding: 0;
}

body {
  background: #fefefe;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-family: 'Mulish', sans-serif;
}

a {
  color: #05a552;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  padding: 10px;
  transition: ease .3s all;
}
a:hover {
  color: #036d36;
}

</style>



// WEBPACK FOOTER //
// src/App.vue